( function($) {
	/**
	 * Search members list via either name or email
	 */
	$( ".search-field" ).on( "keyup", function() {
    const searchTerm = $( this ).val().toLowerCase();
    const listItems = $( "table tbody tr" );

    listItems.each(function() {
			$( this ).find( '.search-needle-email' ).text().toLowerCase();
      
			const name = $( this ).find( '.search-needle' ).text().toLowerCase();
      const email = $( this ).find( '.search-needle-email' ).text().toLowerCase();

      if( name.includes( searchTerm ) || email.includes( searchTerm ) ) {
        $( this ).css( 'display', 'flex' );
      } 
			
			else {
        $( this ).css( 'display', 'none' );
      }
    } );
	} );




	function updateRoleChips() {
		const chipContainer = $( ".role-dropdown-container .chip-container" );
      
		chipContainer.empty();
		$( ".roles-btn" ).css( 'color', 'transparent' ); // keep a space so button doesn't collapse

		// target only role checkboxes
		const checkboxes = $( ".role-dropdown-container .filter-checkbox" );
		
		const selected = checkboxes.filter( ":checked" ).map( function() {
			return $( this ).val();
		} ).get();

		if( selected.length === checkboxes.length ) {
			chipContainer.append( `<div class="chip">All Roles</div>` );
		}
		
		else if ( selected.length === 0 ) {
			$( ".roles-btn" ).css( 'color', '#c2c2c2' );
		}
		
		else {
			selected.forEach( item => {
				const chip = $( `<div class="chip">${item}</div>`);
				
				chipContainer.append( chip );
			});
		}
	}

	function updateRegionChips() {
		const chipContainer = $( ".region-dropdown-container .chip-container" );

		chipContainer.empty();
		$( ".region-btn" ).css( 'color', 'transparent' ); // keep a space so button doesn't collapse

		let chip = '';
		const checkboxes = $( ".region-dropdown-container .filter-checkbox" );
      
		const selected = checkboxes.filter( ":checked" ).map( function() {
			return $( this ).data( 'chip' );
		} ).get();

		if( selected.length === checkboxes.length ) {
			chipContainer.append( `<div class="chip">All Regions</div>` );
		}
			
		else if ( selected.length === 0 ) {
			$( ".region-btn" ).css( 'color', '#c2c2c2' );
		}
		
		else if( selected.length > 1 ) {
			chip = $( `<div class="chip">` + selected.length + ` Regions</div>`);

			chipContainer.append( chip );
		}

		else {
			selected.forEach( item => {
				chip = $( `<div class="chip">${item}</div>`);

				chipContainer.append( chip );
			} );
		}
	}


	/**
	 * Filter list with the role and / or region dropdowns
	 */
 	$( '.filter-checkbox' ).on( 'change', function() {
		let selectedGroup = $( this ).data( 'group' );
		
		if( selectedGroup === 'role' ) {
			updateRoleChips();
		}

		if( selectedGroup === 'region' ) {
			updateRegionChips();
		}

		const groups = {};

    // Build checked values per group
    $( '.filter-checkbox:checked' ).each(function() {
      const group = $( this ).data( 'group' );
			let value;
      
			if( group === 'region' ) {
				value = parseInt( $( this ).val(), 10 );
			}

			else {
				value = $( this ).val();
			}

			if( !groups[ group ] ) {
				groups[ group ] = [];
      }
      
			groups[ group ].push( value );
    });

		// Define which groups exist
    const allGroups = [ 'role', 'region' ];

		$( '.filter-items-container tr' ).each( function () {
      const item = $( this );
      
			let visible = true;

      // Get inner text from nested elements
      const roleVal   = item.find( '.role' ).data( 'role' );
      const regionVal = parseInt( item.find( '.region' ).data( 'value' ), 10 );

			// console.log( 'roleVal::', roleVal );

      // Compare per group
      allGroups.forEach( function( group ) {
        const selectedValues = groups[ group ];

        // Skip this group if no checkboxes selected
        if( !selectedValues || selectedValues.length === 0 ) { return; }

        // Get the item's value for this group
        let itemValue = '';

        if( group === 'role' ) {
          itemValue = roleVal;
        } 
				
				else if( group === 'region' ) {
          itemValue = regionVal;
        }

        // If not in selected values, hide
        if( !selectedValues.includes( itemValue ) ) {
          visible = false;
        }
      } );

      item.toggle( visible );
    } );
	} );



	/**
	 * Clear filter fields
	 */
	$( '.clean-filter' ).on( 'click', function(e) {
		e.preventDefault();

		$( ".filter-checkbox" ).prop( 'checked', false );
		$( ".search-field" ).val( '' ).keyup();
		$( "table tbody tr" ).css( 'display', 'flex' );
		$( ".chip-container" ).empty();
		$( ".roles-btn" ).css( 'color', '#c2c2c2' );
		$( ".region-btn" ).css( 'color', '#c2c2c2' );
	} );
} )( jQuery );
